// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { metachainIstanbul as _metachainIstanbul } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the metachainIstanbul chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1453
 * Chain Name: MetaChain Istanbul
 * Default Block Explorer: https://istanbul-explorer.metachain.dev
 * Default RPC URL: https://istanbul-rpc.metachain.dev
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { metachainIstanbul } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: metachainIstanbul,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const metachainIstanbul = createCommon({
	..._metachainIstanbul,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
